import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Kernel from './Kernel';

export class Fancybox extends Kernel {
    constructor (target) {
        console.log('Module: Fancybox has been loaded');

        super(target);

        this.$fancybox = $('.fancybox');

        this.$fancybox.fancybox({
            loop: true,
            animationEffect: 'fade',
            transitionEffect: 'tube',
            buttons: ['close'],

        });
    }

    destroy () {
        console.log('%cModule: Fancybox has been destroyed', 'color: red;');

        this.$el.off();
    }
}


// WEBPACK FOOTER //
// ./app/src/js/modules/Fancybox.js